import React, { useState, lazy, Suspense, useEffect } from "react";
import Input from "../../UI/Input/Input";
import BaseButton from "../../UI/BaseButton/BaseButton";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { Stack, InputLabel, Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { 
  voucherWithdrawal, 
  verifyCardToken, 
  barcodeWithdrawal
} from "../../../util/API/transfer";
import PinPad from "../../PinPad/PinPad";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { countryList } from "../../../constants/countrylist";
import { getErrorMessage2 } from "../../../util/utilfunctions/utilFunctions";

const LazyQrScanner = lazy(() => import("react-qr-scanner"));


function CustomerWithdrawal() {
  const [tokenID, setTokenID] = useState("");
  const [confirmCode, setConfirmCode] = useState("");
  const [customerPin, setCustomerPin] = useState("");
  const [cardToken, setCardToken] = useState("");
  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [fees, setFees] = useState(0.0);
  const [total, setTotal] = useState(0.0);
  const [isPhysicalCard, setIsPhysicalCard] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("error");
  const [message, setMessage] = useState("");
  const [header, setHeader] = useState("");
  const [customerInformation, setCustomerInformation] = useState([]);
  const [receipt, setReceipt] = useState(false);
  const [receiptID, setReceiptID] = useState({});
  const [disableAmount, setDisableAmount] = useState(true);
  const [showPinPad, setShowPinPad] = useState(false);
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [recipientname, setRecipientname] = useState("");
  const [countdown, setCountdown] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [barcodeActionTriggered, setBarcodeActionTriggered] = useState(false);

  let isAutoRetry;

  useEffect(() => {
    if (!disableAmount) {
      setCountdown(90);
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setDisableAmount(true);
            return null;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval); 
    }
  }, [disableAmount]);

  const user = useSelector((state) => state.usersList.userID);
  let pin = sessionStorage.getItem("pin");
  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;
  const parentuserid = sessionStorage.getItem("parentuserid");
  let isOperator = sessionStorage.getItem("isOperator");
  let configVariables = useSelector((state) => state.config.baseConfig);

  const calculateFee = () => {
    // Set static fee for demonstration purposes
    const calculatedFee = 0.0;
    setFees(calculatedFee)
    if (withdrawalAmount === "") {
      setTotal(0.0);
      return;
    }
    setTotal(parseFloat(withdrawalAmount) - fees);
  }

  // console.log(isOperator)

  const verifyBarcode = async() => {
    setBarcodeActionTriggered(true);
    const response = await verifyCardToken(
      agent['User'].id,
      cardToken,
      parentuserid
    ).then((response) => {
      // console.log(response)
      setCustomerInformation(response.payload.body)
      if (response.callStatus == "1") {
        // console.log(response.recipientname)
        setRecipientname(response.recipientname)
        setDisableAmount(false);
      }
      else {
        setShowAlert(true);
        setSeverity("error");
        setMessage("Could not process withdrawal. " + response.msg);
        setHeader("Error!");
      }
    })
  }

  const scanBarcode = () => {
    setBarcodeActionTriggered(true);
    setShowQRScanner(true);
  }

  const handleScan = (data) => {
    if (data) {
      setCardToken(data.text); // Assuming `data.text` contains the scanned QR code
      setShowQRScanner(false);
    }
  };

  const handleError = (error) => {
    console.error(error);
    setShowAlert(true);
    setSeverity("error");
    setMessage("Failed to scan QR code");
    setHeader("Error!");
  };

  const handleReceipt = () => {
    // const link = isPhysicalCard ? "https://dev2.4pay.ca/portal/www/php/Workflows/mod_genreceipt.php?type=withdrawal&id=" 
    // : "https://dev2.4pay.ca/portal/www/php/Workflows/mod_genreceipt.php?type=voucherwithdrawal&id=";
    const link = isPhysicalCard ? configVariables.baseURL + configVariables.receiptExtension + "/mod_genreceipt.php?type=withdrawal&id=" 
    : configVariables.baseURL + configVariables.receiptExtension + "/mod_genreceipt.php?type=voucherwithdrawal&id=";
    window.open(link + receiptID, "_blank");
  }

  const handleWithdraw = async(event, pin) => {
    // console.log(pin)
    let PIN;
    if (Array.isArray(pin)) {
      PIN = pin.join('');
    }
    else {
      PIN = pin
    }
    barcodeWithdraw(event, PIN);
    setShowPinPad(false);
  }
    
  // console.log(user)

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);
  // console.log(pinConfiguration)

  const barcodeWithdraw = async(event, PIN) => {
    event.preventDefault();
    setReceipt(false);
    // console.log(recipientname)
    try {
      const response = await barcodeWithdrawal(
        customerInformation['forConsumer'].userid, // userid
        customerInformation['forConsumer'].currCode, // currcode
        total, // sendamount
        PIN,   // pin,
        customerInformation['userpi'].id, // pid
        customerInformation['pidetails'].id, // piid
        "", // recipientphone
        "",   // comments,
        recipientname, // recipientname
        "", // recipientemail
        agent['User'].firstName + " " + agent['User'].lastName, // sendername
        agent['User'].cityname, // senderaddress
        countryList.filter((country) => country.value === agent['User'].countryid)[0]?.label, // agent
        "",
        "",
        agent['User'].other1, // senderemail
        "",// recipientaddress,
        "",
        "",   // recipientcountrydat,
        total,
        "",   // txdate,
        PIN,
        agent['User'].id, // agent
        agent['User'].firstName, // agent
        agent['User'].lastName, // agent
        parentuserid,
        isOperator,
        customerPin
      ).then((response) => {
        // console.log(response); 
        if (response.callStatus === "1") {
          setReceipt(true);
          setShowAlert(true);
          setSeverity("success");
          setMessage("Withdraw Completed");
          setHeader("Congratulations!");
          setReceiptID(response.transferid)

          if (pinConfiguration === "once") {
            sessionStorage.setItem("pin", PIN);
          }

          setWithdrawalAmount("");
          setCardToken("");
          setDisableAmount(true);
          setBarcodeActionTriggered(false);
          setTotal(0.0);
        }
        else {
          console.log("error---------",response);
          if(response?.Status == "2" && response?.payload?.status == "2") {
            let errorMsg = getErrorMessage2(response, isAutoRetry = false);
            setShowAlert(true);
            setSeverity("error");
            setMessage("Withdraw Failed: " + errorMsg) 
            setHeader("Error");
          } else if(response?.Status == '2' && response?.payload?.errorNo == "11387-1") {
            setShowAlert(true);
            setSeverity("error");
            setMessage("Withdraw Failed: Invalid Agent Pin");
            setHeader("Error");
          } else if (response?.Status == '2' && response?.payload?.errorNo == "2") {
            setShowAlert(true);
            setSeverity("error");
            setMessage("Withdraw Failed: Invalid Customer Pin");
            setHeader("Error");
          } else {
            setShowAlert(true);
            setSeverity("error");
            setMessage("Withdraw Failed: " + response.payload.msg);
            setHeader("Error");
          }
        }
      });
    }
    catch (error) {

    } finally {
      setCustomerPin("");
    }
  }

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleVoucherWithdrawal(event, PIN);
    setShowPinPad(false);
  };

  // console.log(customerInformation)

  const handleVoucherWithdrawal = async(event, pin) => {
    event.preventDefault();
    setReceipt(false);
    try {
      setIsLoading(true);
      const response = await voucherWithdrawal(
        confirmCode, 
        tokenID,
        agent['User'].id, // agent
        pin,
        agent['User'].firstName, // agent
        agent['User'].lastName, // agent
        agent['User'].cityname, // agent
        countryList.filter((country) => country.value === agent['User'].countryid)[0]?.label, // agent
        parentuserid,
        isOperator
      ).then((response) => {
        if(response.callStatus === "1") {
          setReceipt(true);
          setReceiptID(response.transferid)
          setShowAlert(true);
          setSeverity("success");
          setMessage("Withdraw Completed") 
          setHeader("Congratulations!");
          setConfirmCode("");
          setTokenID("");
        } else {
          console.log("error---------",response);
          setShowAlert(true);
          setSeverity("error");
          setMessage("Withdraw Failed: " + response.payload.msg) 
          setHeader("Error");
        }
      });
    } catch (error) {

    } finally {
      setIsLoading(false);
    }
  };

  const handleWithdrawButton = () => {
    if (isPhysicalCard) {
      if (total === 0) {
        setShowAlert(true);
        setSeverity("error");
        setMessage("Please enter a value to be withdrawn");
        setHeader("Error");
        return;
      }
    }

    if(cardToken.startsWith("455") && customerPin == "") {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please enter a valid customer pin");
      setHeader("Error");
      return;
    }
    setShowPinPad(true);
  }

  return (
    <>
      <div className="customer-deposit-inputs">
      {isLoading == true ? (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
            }}
        >
            <CircularProgress />
        </Box>
      ) : (
        <form>
        <FormControlLabel
          control={<Switch checked={isPhysicalCard} onChange={(e) => setIsPhysicalCard(e.target.checked)} />}
          label="Physical Card: "
          labelPlacement="start"
          sx={{
            '.MuiFormControlLabel-label': {
              fontWeight: '800',
              lineHeight: '33.6px',
              color: '#6b7280',
              fontFamily: 'Nunito',
              fontSize: '14px',
              fontStyle: 'normal',
            },
            marginLeft: '1px', 
            marginTop: '9px',
          }}
        />

        {!isPhysicalCard ? (
          <>
            <Input
              name="tokenID"
              label="Token ID"
              value={tokenID}
              type="string"
              textAlign="right"
              onChange={(e) => setTokenID(e.target.value)}
            />
            <Input
              name="confirmCode"
              label="Confirm Code"
              value={confirmCode}
              type="string"
              textAlign="right"
              onChange={(e) => setConfirmCode(e.target.value)}
            />
            <Stack spacing={1} direction="row" className="button-group d-flex justify-content-end mt-3">
              <BaseButton 
                buttonText={"Withdraw"} 
                onClick={(e) => {{pin ? handleVoucherWithdrawal(e, pin) : pinConfiguration === "never" ? handleVoucherWithdrawal(e, '0000') : setShowPinPad(true)}}}
              />
              {receipt ? <BaseButton 
                buttonText={"Receipt"} 
                buttonStyle="secondary-button-style"
                onClick={() => {handleReceipt()}}
              /> : null}
            </Stack>
          </>
        ) : 
         (
          <>
            <InputLabel sx={{
                fontWeight: '800', 
                lineHeight: '33.6px',
                color: '#6b7280',
                fontFamily: 'Nunito',
                fontSize: '14px',
                fontStyle: 'normal',
              }}>
                Card Token
              </InputLabel>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Input
                name="cardToken"
                value={cardToken}
                type="string"
                textAlign="left"
                onChange={(e) => setCardToken(e.target.value)}
              />
              <Stack direction="row" spacing={1} alignItems="center">
                <IconButton
                  sx={{
                    backgroundColor: 'green',
                    color: 'white',
                    height: '35px',  
                    width: '35px',    
                    padding: 0,       
                    margin: '15px',
                    borderRadius: '4px', 
                    '& .MuiSvgIcon-root': { 
                      fontSize: '20px',
                    },
                    '&:hover': {
                      backgroundColor: 'darkgreen',
                    },
                  }}
                  onClick={() => { verifyBarcode() }}
                >
                  {/* <CheckCircleIcon /> */}
                  {disableAmount ? (
                    <CheckCircleIcon />
                  ) : (
                    <Box sx={{ fontSize: '12px', fontWeight: 'bold', color: 'white' }}>
                      {countdown}s
                    </Box>
                  )}
                </IconButton>
                <IconButton
                  sx={{
                    backgroundColor: 'gray',
                    color: 'white',
                    height: '35px',  
                    width: '35px',    
                    padding: 0,       
                    borderRadius: '4px', 
                    '& .MuiSvgIcon-root': {
                      fontSize: '20px',
                    },
                    '&:hover': {
                      backgroundColor: 'darkgray',
                    },
                  }}
                  onClick={() => { scanBarcode() }}
                >
                  <CameraAltIcon />
                </IconButton>
              </Stack>
            </Stack>
            {showQRScanner && (
              // <QrScanner
              //   delay={300}
              //   onError={handleError}
              //   onScan={handleScan}
              //   style={{ width: "100%" }}
              // />
              <Suspense fallback={<div>Loading QR Scanner...</div>}>
                <LazyQrScanner
                  delay={300}
                  onError={handleError}
                  onScan={handleScan}
                  style={{ width: "100%" }}
                />
              </Suspense>
            )}
            <Input
              name="withdrawalAmount"
              label="Withdrawal Amount"
              value={withdrawalAmount}
              type="string"
              textAlign="right"
              onChange={(e) => setWithdrawalAmount(e.target.value)}
              onBlur={() => calculateFee()}
              disabled={disableAmount}
              />
              {barcodeActionTriggered && cardToken.startsWith("455") && (
                <Input
                  name="customerPin"
                  label="Customer Pin"
                  value={customerPin}
                  type="password"
                  textAlign="left"
                  required
                  onChange={(e) => setCustomerPin(e.target.value)}
                />
              )}
            <div className="info-box">
              <div className="fee d-flex justify-content-end gap-2 align-items-center">
                Fee: <div className="info-box-info">${parseFloat(fees).toFixed(2)}</div>
              </div>
              <div className="total d-flex justify-content-end gap-2 align-items-center">
                Total: <div className="info-box-info">${parseFloat(total).toFixed(2)}</div>
              </div>
            </div>
            <Stack spacing={1} direction="row" className="button-group d-flex justify-content-end mt-3">
              <BaseButton 
                buttonText={"Withdraw"} 
                // disabled={disabled['barcodeDisable']}
                onClick={(event) => {{pin ? handleWithdraw(event, pin) : pinConfiguration === "never" ? handleWithdraw(event, '0000') : handleWithdrawButton()}}}
              />
              {receipt ? <BaseButton 
                buttonText={"Receipt"} 
                buttonStyle="secondary-button-style"
                onClick={() => {handleReceipt()}}
              /> : null}
            </Stack>
          </>
         )
        }
        </form>
      )}
      </div>
      <CustomAlert severity={severity} show={showAlert} header={header} message={message} onClick={() => setShowAlert(false)} autoclose={severity === "error" ? false : true} />
      {showPinPad && <PinPad show={showPinPad} handleConfirm={isPhysicalCard ? handleWithdraw : handleConfirm} onClick={() => setShowPinPad(false)} />}
      <Dialog
        open={showQRScanner}
        onClose={() => setShowQRScanner(false)} // Close modal when clicking outside or Escape key
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          QR Scanner
          <IconButton
            aria-label="close"
            onClick={() => setShowQRScanner(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span style={{ fontSize: "1.5rem" }}>×</span>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {/* <QrScanner
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: "100%" }}
          /> */}
          <Suspense fallback={<div>Loading QR Scanner...</div>}>
            <LazyQrScanner
              delay={300}
              onError={handleError}
              onScan={handleScan}
              style={{ width: "100%" }}
            />
          </Suspense>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowQRScanner(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CustomerWithdrawal;
